import { render, staticRenderFns } from "./AllMechanicDeleted.vue?vue&type=template&id=4f71a0fe&scoped=true"
import script from "./AllMechanicDeleted.vue?vue&type=script&lang=js"
export * from "./AllMechanicDeleted.vue?vue&type=script&lang=js"
import style0 from "./AllMechanicDeleted.vue?vue&type=style&index=0&id=4f71a0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f71a0fe",
  null
  
)

export default component.exports